import { eventService } from "../services/event-service";
import { EVENT_CTA_GET_STARTED_CLICK } from "shared";
import { pushState } from "./route-util";
import { ROUTES } from "../config";
import { html } from "lit";
import { repeat } from "lit/directives/repeat.js";
import { DirectiveResult } from "lit/async-directive";

/**
 * Dispatches a darkmode event used for the landing page.
 * @param dark
 */
export function dispatchDarkmodeEvent(dark: boolean) {
	window.dispatchEvent(new CustomEvent("darkmode", { detail: dark, bubbles: true, composed: true }));
}

/**
 * Goes to the get started page while tracking a click event.
 * Ref is the element referer (eg. navbar, hero button and so on)
 * @param ref
 * @param feature
 */
export function getStarted(ref?: string, feature?: string) {
	eventService.trackEvent(EVENT_CTA_GET_STARTED_CLICK, { ref });
	const path = `${ROUTES.getStarted}${feature?.length ? `/${feature}` : ""}`;
	pushState(path);
}

/**
 * Renders feature chips
 * @param features
 */
export function renderFeatureChips(features: (DirectiveResult | string)[]) {
	return html`
		<style>
			.feature-chips {
				display: flex;
				flex-wrap: wrap;
				gap: var(--space-m);
				margin: var(--space-l) 0 0 0;
			}

			.feature-chip {
				padding: var(--space-s) var(--space-xm);
				border-radius: 9999px;
			}

			@media (max-width: 600px) {
				.feature-chips {
					justify-content: center;
				}
			}
		</style>
		<div class="feature-chips">
			${repeat(
				features,
				(feature) => html`
					<bs-chip class="feature-chip">
						<bs-text>${feature}</bs-text>
					</bs-chip>
				`
			)}
		</div>
	`;
}
